import {
  createMockMalariaPayload,
  formatMalariaResults,
  isMalariaRunner,
  normalizeMalariaAnnotationDetections
} from './malaria';
import {
  createMockLeprosyPayload,
  formatLeprosyResults,
  isLeprosyRunner,
  recomputeLeprosyResult
} from './leprosy';

export const aiModelAdapters = [
  {
    modelType: 'leprosy',
    supports: isLeprosyRunner,
    format(jobId, runnerName, data, needsResultSync) {
      return formatLeprosyResults(jobId, runnerName, data, needsResultSync);
    },
    createMockPayload: createMockLeprosyPayload
  },
  {
    modelType: 'malaria',
    supports: isMalariaRunner,
    format(jobId, runnerName, data, needsResultSync) {
      return formatMalariaResults(jobId, runnerName, data, needsResultSync);
    },
    createMockPayload: createMockMalariaPayload
  }
];

export function findAIModelAdapter(runnerName) {
  return aiModelAdapters.find(adapter => adapter.supports(runnerName));
}

export {
  createMockMalariaPayload,
  formatMalariaResults,
  isMalariaRunner,
  normalizeMalariaAnnotationDetections,
  recomputeMalariaResult
} from './malaria';

export {
  createMockLeprosyPayload,
  formatLeprosyResults,
  isLeprosyRunner,
  recomputeLeprosyResult
} from './leprosy';
